import { atom } from 'nanostores'
import { Request, SeatsSelection } from './dto/seats.dto';

export const seatsInitialization = atom<Request>();
export const seatsSelection = atom<SeatsSelection>();

export function setInitialSaleSetsRequest(request: Request) {
  seatsInitialization.set(request);
};

export function getInitialSaleSeatsRequest() {
  return seatsInitialization.get();
};

export function setPassengersSeatsSelection(passengersSeatsSelection) {
  seatsSelection.set(passengersSeatsSelection);
};

export function getPassengersSeatsSelection() {
  return seatsSelection.get();
};